<script lang="ts" setup>
import { useResponsive } from "@composables"

const { isDesktop } = useResponsive()

const cardList = [
    {
        title: "Gratuit, rapide & simple ",
        alt: "Logo de la gratuité",
        description:
            "Une <strong>dizaine de questions</strong> pour recueillir uniquement les <strong>informations nécessaires</strong> : nom, prénom, numéro de compteur, type d'énergie et dates des travaux.",
        logo: "https://res.cloudinary.com/dcoutwkb1/image/upload/q_auto/v1745852759/grow_tree_mnnedw.svg",
        animate:
            "animate-enter fade-in-10 animate-duration-1000 slide-in-from-l-8",
    },
    {
        title: "Données protégées, ni partagées, ni utilisées à votre insu",
        alt: "Logo de la protection des données",
        description:
            "Toutes vos informations sont anonymisées et traitées selon les normes <strong>RGPD</strong>, assurant ainsi la protection de votre vie privée, et <strong>zéro démarchage commercial.</strong>",
        logo: "https://res.cloudinary.com/dcoutwkb1/image/upload/q_auto/v1745852760/handcheck_izymsw.svg",
        animate:
            "animate-enter fade-in-10 animate-duration-1000 slide-in-from-b-8",
    },
    {
        title: "Des aides publiques mieux étudiées",
        alt: "Logo de l'aide publique",
        description:
            "Votre contribution aide à évaluer les économies d'énergie post-rénovation avec le <strong>CSTB</strong>, pour mieux <strong>ajuster</strong> les aides publiques.",
        logo: "https://res.cloudinary.com/dcoutwkb1/image/upload/q_auto/v1745852760/save_money_twavob.svg",
        animate:
            "animate-enter fade-in-10 animate-duration-1000 slide-in-from-r-8",
    },
]
</script>

<template>
    <div class="why-participate-section">
        <h3 class="why-participate-section__title">
            Pourquoi je participe à
            <img
                src="https://res.cloudinary.com/dcoutwkb1/image/upload/q_auto/v1745851008/logo_black_qzgz7i.svg"
                alt="WattWatchers"
                class="why-participate-section__title-logo"
                loading="lazy"
            />
            ?
        </h3>
        <!-- Liste de cartes -->
        <div class="why-participate-section__cards">
            <div
                v-for="(card, index) in cardList"
                :key="index"
                v-animateonscrollv2="
                    isDesktop && {
                        enterClass: card.animate,
                    }
                "
                class="why-participate-section__card"
            >
                <img
                    :src="card.logo"
                    loading="lazy"
                    :alt="card.alt"
                    class="why-participate-section__card-image"
                />
                <h4 class="why-participate-section__card-title">
                    {{ card.title }}
                </h4>
                <div class="why-participate-section__card-description">
                    <p v-html="card.description"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
@import "@styles/breakpoints.css";

.why-participate-section {
    display: flex;
    padding: 6.25rem 0rem 5rem 0rem;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 3.5rem;
    align-self: stretch;

    @media (--large-viewport) {
        /** Pour s'assurer de bien commencer au début du block lors du scrollIntoView */
        scroll-margin-top: 7rem;
    }

    @media (--medium-viewport) {
        padding: 0;
        scroll-margin-top: 0;
    }

    .why-participate-section__title {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: 0.25rem;

        color: #092754;

        font-size: 2rem;
        font-weight: 600;

        .why-participate-section__title-logo {
            width: 15rem;
            height: 1.5rem;
        }
    }

    .why-participate-section__cards {
        display: flex;
        align-items: flex-start;
        gap: 1rem;
        align-self: stretch;

        /* Sur mobile */
        @media (--medium-viewport) {
            display: grid;
            grid-template-columns: repeat(3, 17.5rem);
            overflow-y: scroll;
            padding: 0.5rem;
        }
    }

    .why-participate-section__card {
        display: flex;
        padding: 3.5rem 1rem;
        flex-direction: column;
        align-items: center;
        gap: 2rem;
        flex: 1 0 0;
        align-self: stretch;

        border-radius: 2rem;
        background: #fff;

        /* Shadow 100 */
        box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.1);

        border: 2px solid transparent;

        transition:
            border-color 0.3s ease-in,
            color 0.3s ease-in;

        /* Sur tablet */
        @media (--large-viewport) {
            gap: 3rem;
        }

        /* Sur mobile */
        @media (--medium-viewport) {
            gap: 1rem;
        }

        &:hover {
            border-radius: 2rem;
            border: 2px solid #1d6ee7;
            background: #fff;

            /* Shadow 300 */
            box-shadow: 0px 1px 24px 0px rgba(0, 0, 0, 0.1);

            p {
                color: #1d6ee7 !important;
            }
        }

        .why-participate-section__card-image {
            display: flex;
            height: 11rem;
            justify-content: center;
            align-items: center;
            aspect-ratio: 1/1;
        }

        .why-participate-section__card-title {
            display: flex;
            align-items: center;
            color: #1d6ee7;
            text-align: center;
            font-size: 1.5rem;
            font-weight: 600;
            height: 5.5rem;
        }

        .why-participate-section__card-description {
            display: flex;
            align-items: center;

            p {
                color: #092754;
                text-align: center;
                font-size: 1rem;
                font-weight: 400;
                line-height: 160%; /* 2.4rem */

                strong {
                    font-weight: 700;
                }
            }
        }
    }
}
</style>
